import { ScrollArea } from "web-design-system";
import { useCallback, useMemo } from "react";
import { findStepConfig } from "@planning/config";
import {
  ProposalUIState,
  useProposalBuilderContext,
} from "../../providers/proposal-provider";

export function ProposalBody() {
  const { uiState, next, prev, goTo } = useProposalBuilderContext();

  const Body = useMemo(() => findStepConfig(uiState)?.component, [uiState]);

  const handleGoTo = useCallback(
    (id: string) => goTo(id as ProposalUIState),
    [goTo]
  );

  if (!Body) throw new Error(`Body not found for UI state: ${uiState}`);

  return (
    <ScrollArea className="flex-1">
      <div className="py-4 px-6 flex flex-col flex-1 w-full">
        <Body next={next} prev={prev} goTo={handleGoTo} />
      </div>
    </ScrollArea>
  );
}
